/**
 * Checks if the difference between two dates exceeds a specified number of days
 * @param startDate - Start date timestamp
 * @param endDate - End date timestamp
 * @param daysThreshold - Number of days threshold (default: 365)
 * @returns true if the date range exceeds the threshold, false otherwise
 */
export const isDateRangeExceedsDays = (
  startDate: number | undefined,
  endDate: number | undefined,
  daysThreshold = 365
): boolean => {
  if (!startDate || !endDate) {
    return false;
  }
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffInMs = end.getTime() - start.getTime();
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
  return diffInDays > daysThreshold;
};

/**
 * Checks if the difference between two dates is more than 1 year (365 days)
 * @param startDate - Start date timestamp
 * @param endDate - End date timestamp
 * @returns true if the date range is more than 1 year, false otherwise
 */
export const isDateRangeMoreThanOneYear = (
  startDate: number | undefined,
  endDate: number | undefined
): boolean => {
  return isDateRangeExceedsDays(startDate, endDate, 365);
};
